var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1448_1139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 32L26 22M6 13.6667C6 15.1988 6.30177 16.7158 6.88807 18.1313C7.47438 19.5468 8.33374 20.8329 9.41709 21.9162C10.5004 22.9996 11.7866 23.859 13.202 24.4453C14.6175 25.0316 16.1346 25.3333 17.6667 25.3333C19.1988 25.3333 20.7158 25.0316 22.1313 24.4453C23.5468 23.859 24.8329 22.9996 25.9162 21.9162C26.9996 20.8329 27.859 19.5468 28.4453 18.1313C29.0316 16.7158 29.3333 15.1988 29.3333 13.6667C29.3333 12.1346 29.0316 10.6175 28.4453 9.20203C27.859 7.78656 26.9996 6.50044 25.9162 5.41709C24.8329 4.33374 23.5468 3.47438 22.1313 2.88807C20.7158 2.30177 19.1988 2 17.6667 2C16.1346 2 14.6175 2.30177 13.202 2.88807C11.7866 3.47438 10.5004 4.33374 9.41709 5.41709C8.33374 6.50044 7.47438 7.78656 6.88807 9.20203C6.30177 10.6175 6 12.1346 6 13.6667Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1448_1139",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0980392 0 0 0 0 0.611765 0 0 0 0 0.709804 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1448_1139"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1448_1139",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.2b0e07bbd83037dd29b7b108ea1bdba9.svg";
export { ForwardRef as ReactComponent };